import React, { type FC, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { type WidgetInternalProps } from '../../types/WidgetProps';
import { DH } from '../../utils/dataHooks';
import { WidgetRootResources } from './root-resources';

const generateUniqueDH = () => `express-checkout-widget-${Math.random().toString(36).substr(2, 9)}`;

export const RootWrapper: FC<WidgetInternalProps> = (props) => {
  const [widgetRootWrapperDh] = useState(generateUniqueDH());

  return (
    <div data-hook={widgetRootWrapperDh}>
      <ErrorBoundary fallback={<span data-hook={DH.Widget.ErrorBoundaryFallback} />}>
        <WidgetRootResources {...props} widgetRootWrapperDh={widgetRootWrapperDh} />
      </ErrorBoundary>
    </div>
  );
};
RootWrapper.displayName = 'RootWrapper';
